import request from "@/utils/request";

// export function downloadOrganizationDocumentByName(params) {
//   console.log(params)
//   console.log(params.source)
//   console.log(params.source.split('.')[1])
//   if (params.source.split('.')[1]==='pdf' || params.source.split('.')[1]==='PDF'){
//       return request({
//           url: `/page-sign/download-by-name`,
//           method: 'get',
//           responseType: '',
//           headers: {
//               'Accept': 'application/pdf'
//           },
//           params
//       })
//   }else{
//       return request({
//           url: `/page-sign/download-by-name`,
//           method: 'get',
//           responseType: 'blob',
//           params
//       })
//   }
// }

export function downloadOrganizationDocumentByName(params) {
  return request({
    url: `/page-sign/download-by-name`,
    method: "get",
    responseType: "blob",
    params
  });
}

// export function downloadOrganizationDocumentByName(params) {
//     fetch('https://lk-api.isfg.ru/page-sign/download-by-name?source='+params.source,
//         {
//             headers: {
//                 'Accept': 'application/octet-stream',
//             },
//             responseType: 'blob',
//         }
//     )
// }
